
(function() {
  var result = { translations: { "tl": { "i18n": { "duration": { "seconds": "{{ seconds }} segundo", "minutes": "{{ minutes }} minuto", "hours": "{{ hours }} oras", "hoursAndMinutes": "{{ hours }} oras {{ minutes }} minuto", "days": "{{ days }} (na) araw", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "tl": "static-7.967"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.967",
    "ar-eg": "static-7.967",
    "bg": "static-7.967",
    "bn": "static-7.967",
    "ca-es": "static-7.967",
    "cs": "static-7.967",
    "da": "static-7.967",
    "de": "static-7.967",
    "el": "static-7.967",
    "en-gb": "static-7.967",
    "en": "static-7.967",
    "es-mx": "static-7.967",
    "es": "static-7.967",
    "fi": "static-7.967",
    "fr-ca": "static-7.967",
    "fr": "static-7.967",
    "he-il": "static-7.967",
    "hr": "static-7.967",
    "hu": "static-7.967",
    "id": "static-7.967",
    "it": "static-7.967",
    "ja": "static-7.967",
    "ko": "static-7.967",
    "lt": "static-7.967",
    "ms": "static-7.967",
    "nl": "static-7.967",
    "no": "static-7.967",
    "pl": "static-7.967",
    "pt-br": "static-7.967",
    "pt-pt": "static-7.967",
    "ro": "static-7.967",
    "ru": "static-7.967",
    "sk": "static-7.967",
    "sl": "static-7.967",
    "sv": "static-7.967",
    "th": "static-7.967",
    "tl": "static-7.967",
    "tr": "static-7.967",
    "uk": "static-7.967",
    "vi": "static-7.967",
    "x-pseudo": "static-7.967",
    "zh-cn": "static-7.967",
    "zh-hk": "static-7.967",
    "zh-tw": "static-7.967"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:tl', {version: 'static-7.967'}); }
})();


